// components/dashboard/OrdersChart.jsx
import React from 'react';

const OrdersChart = ({ data }) => {
    return (
        <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="text-lg font-medium mb-4">訂單趨勢</h3>
            <div className="h-60 flex items-center justify-center bg-gray-100 rounded">
                <p className="text-gray-500">訂單圖表將在此處顯示</p>
            </div>
        </div>
    );
};

export default OrdersChart;